import { Notification } from 'element-ui'
import io from 'socket.io-client'
import { PushDetail } from '@/types/Message'
import router from './router/home'
import i18n from '@/i18n/home'

let socket: SocketIOClient.Socket
/**
 * map 结果页面路由
 */
function msgTypeResultRouteMap (msgDetail: any) {
  const lang = router.currentRoute.params.lang
  const msgTypeResultRouteMap: { [key: string]: string } = {
    PreProcessing: `/${lang}/PreProcessing/result/${msgDetail.id}`,
    DataIntegration: `/${lang}/DataIntegration/result/${msgDetail.id}`,
    Clustering: `/${lang}/Clustering/result/${msgDetail.id}`,
    DifferentialExpression: `/${lang}/DifferentialExpression/result/${msgDetail.id}`,
    CellTypeAnnotation: `/${lang}/CellTypeAnnotation/result/${msgDetail.id}`,
    TrajectoryAnalysis: `/${lang}/TrajectoryAnalysis/result/${msgDetail.id}`,
    AdvancedDownstreamAnalysis: `/${lang}/AdvancedDownstreamAnalysis/result/${msgDetail.id}`,
    GeneSetEnrichment: `/${lang}/GeneSetEnrichment/result/${msgDetail.id}`,
    CellCommunication: `/${lang}/CellCommunication/result/${msgDetail.id}`,
    InferCNV: `/${lang}/InferCNV/result/${msgDetail.id}`,
    ConvertFastq: `/${lang}/TaskManagement`
  }
  return msgTypeResultRouteMap[msgDetail.category]
}

function routerNameMap (category: string) {
  return i18n.t(`nav.${category}`)
}

/**
 * 显示任务提示，实时推送
 * @param msgDetail 消息详情
 */
function showTask (msgDetail: PushDetail) {
  const notify = Notification({
    title: msgDetail.type === 'success' ? `${routerNameMap(msgDetail.category)} ${i18n.t('task.taskSuccess')}` : `${routerNameMap(msgDetail.category)} ${i18n.t('task.taskFailed')}`,
    duration: 60000,
    type: msgDetail.type,
    offset: 75,
    dangerouslyUseHTMLString: true,
    message: `<p style="text-decoration: underline;color: #409EFF;cursor: pointer;">
                 ${i18n.t('task.createTime')}: ${msgDetail.create_time}
              </p>`,
    onClick () {
      if (msgDetail.type === 'success') {
        router.push(msgTypeResultRouteMap(msgDetail)).catch(err => err)
        notify.close()
      }
    }
  })
}

/**
 * 更新cirro数据
 */
function showUpdate (data: any) {
  const notify = Notification({
    title: data.code === 0 ? '更新成功' : '更新失败',
    duration: 30000,
    type: data.code === 0 ? 'success' : 'error',
    offset: 75,
    dangerouslyUseHTMLString: true,
    message: `<p style="text-decoration: underline;color: #409EFF;cursor: pointer;">
                ${routerNameMap(data.category)}任务结果${data.columns}更新
              </p>`,
    onClick () {
      if (data.code === 0) {
        router.push(msgTypeResultRouteMap(data)).catch(err => err)
        notify.close()
      }
    }
  })
}

/**
 * 建立 websocket 连接
 */
function initSocket (wsUrl: string = '/') {
  socket = io(wsUrl, { transports: ['websocket'] })
  socket.on('job_finish', function (data: PushDetail) {
    showTask(data)
  })
  socket.on('update_finish', function (data: any) {
    showUpdate(data)
  })
  return socket
}

// 销毁 websocket 连接
function destroySocket () {
  if (!socket) return
  socket.off('msg_resp')
  socket.close()
  // @ts-ignore
  socket.destroy()
  // @ts-ignore
  socket = null
}

// 获取 socket 对象, 因为刚开始没有初始化, 所以后面通过这个方法获取
function getSocket () {
  return socket
}

export { initSocket, destroySocket, getSocket }
